/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(entityId) {
  var defer = $.Deferred();
  $.soap({
    body: {
      GetEntityByID: {
        $xmlns: 'http://dobs.pa.gov/co/entity/bpm/1.0',
        EntityID: entityId
      }
    },
    blueprintArrays: ['GetEntityByIDResponse.CO_Entity'],
    blueprint: {
      id: '$..ID',
      name: '$..Name',
      entityTypeId: '$..EntityTypeID',
      organizationTypeId: '$..OrganizationTypeID',
      website: '$..Website',
      addressLine1: '$..AddressLine1',
      addressLine2: '$..AddressLine2',
      city: '$..City',
      state: '$..State',
      postalCode: '$..PostalCode',
      county: '$..County',
      country: '$..Country'
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      defer.resolve(response);
    })
    .fail(function(err) {
      defer.reject(err);
    });

  return defer.promise();
};
